export default function ({ $axios, $cookies }) {
  $axios.onRequest(config => {
      const token = $cookies.get('epeca-hub-b2c/token') || ''
      config.headers["Authorization"] = token;   
  })
}
